<template>
  <div class="page-content">
   <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Support</h4>
               <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                     <li class="breadcrumb-item"><a href="javascript: void(0);">Support</a></li>
                     <li class="breadcrumb-item active">Tickets</li>
                  </ol>
               </div>
            </div>
         </div>
      </div>
      <!-- end page title -->
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <div class="row mb-2">
                     <div class="col-sm-4">
                        <div class="search-box mr-2 mb-2 d-inline-block">
                           <div class="position-relative">
                              <input type="text" class="form-control" placeholder="Search...">
                              <i class="bx bx-search-alt search-icon"></i>
                           </div>
                        </div>
                     </div>
                     <div class="col-sm-8">
                        <div class="text-sm-right">
                           <router-link :to="{ name: 'create-ticket'}" type="button" class="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"><i class="mdi mdi-plus mr-1"></i> Create New Ticket</router-link>
                        </div>
                     </div>
                     <!-- end col-->
                  </div>
                  <div class="table-responsive">
                     <table class="table table-centered table-nowrap">
                        <thead class="thead-light">
                           <tr>
                              <th style="width: 20px;">
                                 <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1">
                                    <label class="custom-control-label" for="customCheck1">&nbsp;</label>
                                 </div>
                              </th>
                              <th>Ticket #</th>
                              <th>Department</th>
                              <th>Subject</th>
                              <th>Last Updated</th>
                              <th>Status</th>
                              <th>Action</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-bind:key="ticket.id" v-for="ticket in tickets">
                              <td>
                                 <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" :id="'checkbox_' + ticket.id">
                                    <label class="custom-control-label" :for="'checkbox_' + ticket.id">&nbsp;</label>
                                 </div>
                              </td>
                              <td><router-link :to="{ name: 'view-ticket', params: {id: ticket.id} }" class="text-body font-weight-bold">#{{ticket.id}}</router-link></td>
                              <td>{{ ticket.department}}</td>
                              <td>
                                 {{ticket.subject}}
                              </td>
                              <td>
                                {{ ticket.lastUpdated}}
                              </td>
                              <td>
                                 <span :class="statusClass(ticket.status)">{{ ticket.status}}</span>
                              </td>
                              <td>
                                 <!-- Button trigger modal -->
                                 <router-link :to="{ name: 'view-ticket', params: {id: ticket.id} }" class="btn btn-primary btn-sm btn-rounded">View</router-link>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <ul class="pagination pagination-rounded justify-content-end mb-2">
                     <li class="page-item disabled">
                        <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                        <i class="mdi mdi-chevron-left"></i>
                        </a>
                     </li>
                     <li class="page-item active"><a class="page-link" href="javascript: void(0);">1</a></li>
                     <li class="page-item"><a class="page-link" href="javascript: void(0);">2</a></li>
                     <li class="page-item">
                        <a class="page-link" href="javascript: void(0);" aria-label="Next">
                        <i class="mdi mdi-chevron-right"></i>
                        </a>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
      <!-- end row -->
      <!-- end row -->
      <!-- end row -->
   </div>
</div>
</template>

<script>
import store from '../../../store'
export default{
  name: 'Support',
  data () {
    return {
      tickets: []
    }
  },
  created () {
    this.getTickets()
    console.log('created')
  },
  methods: {
    getTickets: function () {
      fetch(store.state.url + '/tickets/list', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + store.state.token
        }
      }).then(response => {
        return response.json()
      }).then(data => {
        this.tickets = data
      }).catch(err => {
        console.error(err)
      })
    },
    statusClass: function (status) {
      var baseClass = 'badge badge-pill font-size-12 '
      switch (status) {
        case 'Open':
          baseClass += 'badge-success'
          break
        case 'Answered':
          baseClass += 'badge-light'
          break
        case 'Customer-Reply':
          baseClass += 'badge-warning'
          break
        case 'On Hold':
          baseClass += 'badge-danger'
          break
        case 'In Progress':
          baseClass += 'badge-info'
          break
        case 'Closed':
          baseClass += 'badge-secondary'
          break
        default:
          baseClass += 'badge-light'
      }
      return baseClass
    }
  }
}</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/management/support/Support.vue